import { all, AllEffect } from '@redux-saga/core/effects';
import { call, Effect } from 'redux-saga/effects';

import getReceiptDataSaga from './getReceiptDataSaga';
import getReceiptSaga from './getReceiptSaga';
import updateReceiptSaga from './updateReceiptSaga';

export default function* requestInformationSaga(): Generator<AllEffect<Effect>, void, unknown> {
  yield all([call(getReceiptDataSaga), call(getReceiptSaga), call(updateReceiptSaga)]);
}
